import * as React from 'react';
import {
  Box,
  Card,
  Typography,
  Divider
} from '@mui/material'

import { useSelector, useDispatch } from 'react-redux';
import { DragDropContext } from 'react-beautiful-dnd';

import SimpleBar from 'simplebar-react';
import Toolbar from '../components/Toolbar'
import Panel from '../components/Presentation/Panel';

import { CSettingButton } from '../components/common/Modal';
import PresentationModal from '../modals/PresentationModal';

import { getPresentation, createPresentation, moveSlide } from '../slices/presentation';

export default function Presentation() {
  const presentations = useSelector(state => state.presentation.presentations);

  const [openPresentation, setOpenPresentation] = React.useState(false);
  const [title, setTitle] = React.useState('');
  const [model, setModel] = React.useState('');
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getPresentation());
  }, [dispatch]);

  const handleCreatePresentation = () => {
    setOpenPresentation(true)
  }

  const handleSavePresentation = (title, model) => {
    dispatch(createPresentation({title, model}))
      .then(res => {
        setOpenPresentation(false);
      })
      .catch(err => {
        console.log(err);
        setOpenPresentation(false);
      });
  }

  const handleClosePresentation = () => {
    setOpenPresentation(false);
    setTitle('');
    setModel('');
  }

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;

    dispatch(moveSlide({sourceId: source.droppableId, sourceIndex: source.index, destinationId: destination.droppableId, destinationIndex: destination.index}))
  }

  return(
    <Box className="w-full h-full ">
      <Toolbar/>
      <Box className="content-height" sx={{padding: 4}}>
        <Card className='h-full flex flex-column border-content' sx={{boxShadow: 'rgba(145, 158, 171, 0.3) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px'}}>
          <Box className='flex flex-row' sx={{padding: 3, flexGrow: 0}}>
            <Typography variant='h6' sx={{flexGrow: 1}}>Presentation</Typography>
            <CSettingButton
              sx={{
                background: '#5D87FF',
                color: 'white',
                padding: '0.25rem 1rem',
                '&:hover': {
                  background: '#6695FF'
                }
              }}
              onClick={handleCreatePresentation}
            >
              New Presentation
            </CSettingButton>    
          </Box>
          <Divider/>
          <Box sx={{padding: 2, flexGrow: 1, height: 'calc(100% - 120px)'}}>
            <SimpleBar forceVisible="x"  style={{maxWidth: '100%', height: '100%'}}>
              <Box className='flex flex-row' sx={{alignItems: 'flex-start', width: '100%', gap: 2, height: '100%'}}>
                <DragDropContext onDragEnd={onDragEnd}>
                  {
                    presentations && presentations.length>0 && presentations.map((presentation, i) => (
                      <Panel 
                        key={i}
                        id={presentation.id}
                        index={i}
                        title={presentation.title}
                        model={presentation.model}
                        items={presentation.items}
                      />
                    ))
                  }
                </DragDropContext>
              </Box>
            </SimpleBar>
          </Box>
        </Card>
      </Box>
      <PresentationModal
        open={openPresentation}
        defaultTitle={title}
        defaultModel={model}
        handleSave={handleSavePresentation}
        handleClose={handleClosePresentation}
      />
    </Box>
  );
}